import { createFileRoute } from "@tanstack/react-router";
import LoadingPage from "lib/components/layout/LoadingPage";
import withAuthentication from "../../../../components/withAuthentication";

/**
 * Editor for a saved `HomePlan`. Loads from the `home-plans/base-data` API
 * and is the flow CTA submissions funnel into — editable for single-unit
 * plans, read-only overview for multi-unit. Gated on `showroomUnification`.
 */
function ShowroomPlan() {
  return <LoadingPage pageTitle="Showroom" />;
}

export const Route = createFileRoute("/showroom/plan/$home_plan_id/")({
  component: withAuthentication(ShowroomPlan, {
    features: ["showroomUnification"],
    permissions: ["VIEW_HOME_PLANS"],
    products: ["showroom"],
  }),
});
